<template>

  <transition 
    name="fade" 
    v-on:enter="enter" 
    v-on:leave="leave">

    <div id="dossier" v-on:click="onClick">
      <div class="inner" ref="inner">
        <div class="bg-image-wrap" ref="bgImg"></div>
        <div class="content" ref="content">
          <div class="stamp-two"></div> 
          <h2 ref="title" class="title">
            Project <br> Mood
          </h2> 
          <p>
            <span class="sub-title">
              2.Case (0013) - Human World
            </span>
            <span class="body">
              <span class="hide">___</span> After a lengthy surveillance operation of the human world, we have finally retrieved our first test subject. 
              <br>
              This is Ed. Ed has <span class="redacted-one">'emptiness'</span> ‘feelings’
              <br>
              <br>
              <span class="cta">Now we can begin our experimentation and find out how these <span class="highlight">‘feelings’work.</span> </span> 
            </span>
          </p>
          <div class="stamp-one"></div>
          <div class="sig-one"></div> 
        </div>
      </div>
    </div>
  </transition>

</template>

<script>


import { mapState, mapMutations } from 'vuex' 
import TweenMax from 'gsap'
import ImageService from 'src/services/ImageService'

export default {

  name: 'dossier',
  
  components: {},
  
  data() {
    return { 
    }
  },
  
  computed: {
    ...mapState('app', ['loading'])
  },
  
  mounted() {
    let img = ImageService.get(require('@/assets/img/dossier-paper.png'))
    img.classList.add('bg-image')
    this.$refs.bgImg.appendChild(img)

    TweenMax.to(this.$refs.inner, 1.5, {
      scale: 1,
      ease: 'Expo.easeInOut'
    })
    TweenMax.to(this.$refs.inner, 1.5, { 
      opacity: 1,
      ease: 'Expo.easeOut'
    })

    TweenMax.to(this.$refs.content, 1, { 
      opacity: 1,
      delay: 1,
      ease: 'Sine.easeInOut'
    })
  },
  
  beforeDestroy() {},
  
  methods: {

    onClick() {
      this.$router.replace({ name: 'question' });
    },

    enter(){ },

    leave(){ }
  },
  
  watch: { 
    'loading.completed'(val){}
  }

}

</script>

<style lang="sass" >
@import "src/styles/common.sass"

#dossier
  +full()
  +flex-center()

  .content
    position: relative;
    z-index: 1;
    padding: 6rem 5rem;
    opacity: 0;

  .inner
    width: 96%;
    font-size: 1.4rem; 
    line-height: 2;
    position: relative; 
    transform: scale(1.3);
    opacity: 0;

    .bg-image-wrap 
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;

    .bg-image
      width: 100%;

    p
      margin-bottom: 2rem;

    .bg
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      padding: 3rem;

      img
        width: 100%;
        height: 100%;

    .sub-title
      font-weight: bolder;
      font-size: 1.2rem;
      letter-spacing: 0.05rem;

    .body
      font-size: 1.2rem;
      margin-top: 1.5rem;
      display: block;

    .hide
      opacity: 0;

    .redacted
      background: url('~assets/img/dossier-stamp-1.png');
      background-repeat: no-repeat;
      background-size: contain;

    .cta
      text-align: right;
 

    h2.title
      color: #363532;
      font-size: 2.2rem;
      line-height: 1.2;
      font-weight: 300;
      text-transform: uppercase;
      font-family: monospace;
      margin: 0.75rem 0 2rem;


    .stamp-one
      background: url('~assets/img/dossier-stamp-1.png');
      background-repeat: no-repeat;
      background-size: contain;
      width: 100px;
      height: 40px;
      position: absolute;
      right: 2.7rem;
      top: 4.3rem;

    .stamp-two
      background: url('~assets/img/dossier-stamp-2.png');
      background-repeat: no-repeat;
      background-size: contain;
      width: 162px;
      height: 110px;
      position: absolute;
      left: 0rem;
      bottom: 0rem;
      z-index: 0;

    .redacted-one
      background: url('~assets/img/dossier-redacted-2.png');
      background-repeat: no-repeat;
      background-size: contain; 

    .highlight
      background: url('~assets/img/dossier-highlight.png');
      background-repeat: no-repeat;
      background-size: cover; 

    .sig-one
      background: url('~assets/img/dossier-sig.png');
      background-repeat: no-repeat;
      background-size: contain; 
      width: 76px;
      height: 40px;
      position: absolute;
      right: 0;
      bottom: 14rem;


</style>







